import { useEffect, useState } from "react";
import { _PayrollEntity, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PayrollEntityProperties } from "./Properties/PayrollEntityProperties";



export const PayrollEntity = () => {
    const { instance, setLista, setBean, bean, lista, handleChange } = useDataBean(_PayrollEntity);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalProps, setModalProps] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const head = [
        { title: 'ID', property: 'IDPayrollEntity', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Contacto', property: 'ContactName', visible: true },
        { title: 'Organización', property: 'AccountEntityName', visible: true },
        { title: 'Día de Corte', property: 'CuttingDay', visible: true },
        { title: 'Habilidado', property: 'Enabled', visible: true },
    ]

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getPayrollEntityCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const updateIten = () => {
        instance.updatePayrollEntity(bean).then(
            (resp) => {
                getLista()
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deletePayrollEntity(bean.IDPayrollEntity).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    const create = () => {
        setBean({
            Enabled: false,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Caja Nominadora" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Caja Nominadora" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Caja Nominadora` }) } },
            { titulo: 'Propiedades de la Caja', icono: 'ri-settings-4-line', visible: _single.canDelete(), evento: () => { setModalProps({ ...modalProps, "view": true, "name": `Propiedades de la Caja` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Cajas Nominadoras" >
            <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar {bean.IDPayrollEntity} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateIten}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Día de Corte</label>
                            <select
                                className="form-select"
                                value={bean.CuttingDay}
                                onChange={(e) =>
                                    setBean({ ...bean, CuttingDay: e.target.value })
                                }
                            >
                                <option value="">...</option>
                                {[...Array(31).keys()].map((day) => (
                                    <option key={day} value={day}>
                                        {day}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDAccountEntity} label="Organización" onChange={(e) => { setBean({ ...bean, "IDAccountEntity": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDAccountContact} label="Contacto" onChange={(e) => { setBean({ ...bean, "IDAccountContact": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={bean.Enabled} eventChange={(e) => { setBean({ ...bean, "Enabled": e }) }} label="¿Habilitado?" />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalProps} updateModal={setModalProps}  >
                    <PayrollEntityProperties payrollEntity={bean.IDPayrollEntity} />
                </Modal>
            </div>

        </BasicPage>
    )
}